import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { msalConfig } from './authConfig';
import { isAuthBypassed } from './authConfig';
import './styles/index.css';
import { MsalProvider } from '@azure/msal-react';

const msalInstance = new PublicClientApplication(msalConfig);

if (isAuthBypassed) {
  // Mock authentication for development
  msalInstance.setActiveAccount({
    homeAccountId: 'mock-home-account-id',
    environment: 'mock-environment',
    tenantId: 'mock-tenant-id',
    username: 'mockuser@domain.com',
    idTokenClaims: {
      name: 'Mock User',
      oid: 'mock-oid',
    },
    localAccountId: '',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

// For production testing: disable StrictMode to replicate production behavior
// StrictMode causes double renders in dev which can hide timing issues
const DISABLE_STRICT_MODE = import.meta.env.VITE_DISABLE_STRICT_MODE === 'true';

const AppWrapper = (
  <MsalProvider instance={msalInstance}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </MsalProvider>
);

root.render(
  DISABLE_STRICT_MODE ? (
    AppWrapper
  ) : (
    <React.StrictMode>{AppWrapper}</React.StrictMode>
  )
);
